import { controls } from '@caslink/device-client/ng-app/shared/models/device-routes.enum';
import { IControlSubRoutes } from '../shared/models/models';

export class RtuControlSubRoutes implements IControlSubRoutes {
    public scheduleState = {
        linkText: 'Schedule',
        name: controls.staticSchedule,
        title: 'Edit Schedule',
        isVisible: (control) => {
            return control.commands.scheduling.isVisible;
        },
        isEnabled: (control) => {
            return control.commands.scheduling.isEnabled;
        }
    };

    public currentInfoState = {
        linkText: 'Advanced',
        name: controls.currentInfo,
        title: 'Advanced',
        isVisible: (control) => {
            return control.commands.currentInformation.isVisible;
        },
        isEnabled: (control) => {
            return control.commands.currentInformation.isEnabled;
        }
    };

    public systemSettingsState = {
        linkText: 'Factory',
        name: controls.systemSettings,
        title: 'Factory',
        isVisible: (control) => {
            return control.commands.systemInformation.isVisible;
        },
        isEnabled: (control) => {
            return control.commands.systemInformation.isEnabled;
        }
    };

    public auditingState = {
        linkText: 'History',
        name: controls.auditing,
        title: 'History',
        isVisible: (control) => {
            return control.commands.controlAuditHistory.isVisible;
        },
        isEnabled: (control) => {
            return control.commands.controlAuditHistory.isEnabled;
        }
    };
}
